import Vue from 'vue';
import store from '../store';

Vue.filter('currency', (value) => {
  const currencyFormatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  });
  return currencyFormatter.format(value);
});

Vue.filter('percentage', (value) => {
  const percentageFormatter = new Intl.NumberFormat('de-DE', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  return percentageFormatter.format(value);
});

Vue.filter('jwtToken', (url) => {
  const token = store.getters.access_token;
  if (!token) {
    return url;
  }
  if (url.includes('?')) {
    return url + '&jwt=' + token;
  } else {
    return url + '?jwt=' + token;
  }
});
